module.exports = __webpack_public_path__ + "img/new1.46b82739.png";